import {NgModule} from '@angular/core';
import {LogoComponent} from './logo/logo.component';
import { InvertedLogoComponent } from './logo/inverted-logo/inverted-logo.component';

@NgModule({
    declarations: [
        LogoComponent,
        InvertedLogoComponent
    ],
    exports: [
        LogoComponent,
        InvertedLogoComponent
    ]
})
export class LogosModule {
}
